export type HostSlotTone = 'evening' | 'overnight' | 'morning' | 'afternoon';

export function formatTimeSlot(slot?: string): string {
  if (!slot) {
    return '';
  }
  return slot
    .replace(/(\d{1,4})\s*(am|pm)/gi, (_full, digits: string, mer: string) => {
      let hour: number;
      let minutes: number;
      if (digits.length <= 2) {
        hour = Number(digits);
        minutes = 0;
      } else if (digits.length === 3) {
        hour = Number(digits.slice(0, 1));
        minutes = Number(digits.slice(1));
      } else {
        hour = Number(digits.slice(0, 2));
        minutes = Number(digits.slice(2));
      }
      return `${hour}:${String(minutes).padStart(2, '0')} ${mer.toUpperCase()}`;
    })
    .replace(/\s+to\s+/i, ' – ');
}

export function slotToneFromLabel(slot?: string, index = 0): HostSlotTone {
  const value = (slot || '').toLowerCase().replace(/\s+/g, '');
  if (value.includes('7pm') || value.includes('1159pm')) {
    return 'evening';
  }
  if (value.includes('1200am') || value.includes('5am')) {
    return 'overnight';
  }
  if (value.includes('501am') || value.includes('12pm')) {
    return 'morning';
  }
  if (value.includes('1201pm') || value.includes('659pm')) {
    return 'afternoon';
  }
  return (['evening', 'overnight', 'morning', 'afternoon'] as const)[index % 4];
}

export function slotIcon(tone: HostSlotTone): string {
  switch (tone) {
    case 'evening':
      return 'brightness_4';
    case 'overnight':
      return 'nights_stay';
    case 'morning':
      return 'wb_sunny';
    default:
      return 'wb_cloudy';
  }
}
